import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Grid, TextField, Button, Paper } from "@material-ui/core";

import slugify from "react-slugify";
import { Link } from "react-router-dom";

import { Spinner, Layout } from "../../components";

import { addArticle } from "../../services/articles.service";

export const NewArticle = () => {
  const [formData, setFormData] = useState({});
  const [id, setId] = useState();
  const [formValided, setFormValided] = useState(true);
  const [formSubmit, setFormSubmit] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);

  const user = useSelector((store) => store.user);

  useEffect(() => {
    const checkFildsForm = formData.title && formData.slug;
    setFormValided(!checkFildsForm);
  }, [formData]);

  const handleTitle = (event) => {
    setFormData({
      ...formData,
      title: event.target.value,
      slug: slugify(event.target.value),
      author: user.id
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setFormSubmit(true);

    try {

      const response = await addArticle(formData);

      setId(response.data.id)

      setFormSuccess(true);
      
    } catch (error) {
      console.log("Error creating article", error);
    }
  };

  return (
    <Layout>
      <div className="main form">
        <h1>Novo artigo</h1>
        <Paper>
          {formSuccess ? (
            <h3 style={{ padding: "30px", textAlign: "center" }}>
              <span>Artigo criado.</span>
              <Link to={`/editar-artigo/${id}`}>Ir para a edição</Link>
            </h3>
          ) : (
            <form noValidate autoComplete="off" className="article__new">
              <Grid container style={{ padding: "30px", textAlign: "center" }}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    disabled={formSubmit}
                    onChange={handleTitle}
                    name="title"
                    label="Título"
                  />
                </Grid>
                {formData.slug && (
                  <Grid item xs={12}>
                    <small style={{ marginTop: "5px", color: "#555" }}>
                      <strong>url:</strong> {formData.slug}
                    </small>
                  </Grid>
                )}
                <Grid item xs={12}>
                  {formSubmit ? (
                    <div className="spinner">
                      <h3>Configurando id, url... </h3>
                      <Spinner />
                    </div>
                  ) : (
                    <Button
                      variant="contained"
                      onClick={handleSubmit}
                      disabled={formValided}
                      color="primary"
                      style={{ marginTop: "20px" }}
                    >
                      Avançar
                    </Button>
                  )}
                </Grid>
              </Grid>
            </form>
          )}
        </Paper>
      </div>
    </Layout>
  );
};

export default NewArticle;